import { render } from "./ModalDealerUfs.vue?vue&type=template&id=0dcc7162&scoped=true"
import script from "./ModalDealerUfs.vue?vue&type=script&lang=js"
export * from "./ModalDealerUfs.vue?vue&type=script&lang=js"

import "./ModalDealerUfs.vue?vue&type=style&index=0&id=0dcc7162&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcc7162"]])

export default __exports__